export const Constants = {
    sendEmailTemplate: 'Email/SendEmailTemplate', 
    sendEmail: 'Email/SendEmail',
}